import React, { useEffect, useState } from 'react';
import './HomeMessage.css';
import axios from 'axios';

const config = require("../../config.json");

export default function HomeMessage({ compact = false, onMessageAvailabilityChange = () => {} }) {
  const messageOfTheWeek = `This week, we pause not to look back with nostalgia, but to look deeper with purpose. Every archive shelf holds more than paper. It holds voices that survived silence, decisions that changed families, and small acts of courage that never reached a headline. In a world that scrolls quickly, archives ask us to stay, to read slowly, and to listen with patience. We discover that history is not a distant story told by strangers; it is a living conversation that still shapes the choices we make today. When a student opens an old letter, when a researcher compares records, when a visitor reads a forgotten note, a bridge appears between generations. That bridge is built from care, accuracy, and trust. It reminds us that preserving memory is not a passive task. It is active service to truth, justice, and community. Let this be our shared practice this week: protect one story, verify one fact, and honor one person whose contribution was nearly lost. If we do that consistently, we do more than maintain collections; we cultivate wisdom. We become stewards of meaning. We teach future readers that details matter, context matters, and human dignity matters. The message of the week is simple: keep the record, keep the wonder, and keep the door open for everyone who seeks understanding. In every preserved page, there is an invitation to learn, to reconcile, and to build a more thoughtful tomorrow together. Let each catalog entry be a promise, each digitized image a lantern, and each translation a welcome. Share this discipline with young learners, collaborators, and elders. When memory is protected with humility and skill, communities heal faster, imagine farther, and hand forward brighter possibilities for future generations. May our work remain careful, generous, and hopeful, one document at a time, for all.`;

  const displayMessage = messageOfTheWeek;
  const sectionClassName = compact ? 'home-message home-message-compact' : 'home-message section';
  const [activePost, setActivePost] = useState([]);
  const [faithMsg, setFaithMsg] = useState({title:"", subtitle:"", message:""});

  useEffect(() => {
    fetchActiveMessage();
   }, []);
  
     const fetchActiveMessage = async () => {
      try {
        const startDate = await generateDate();
        const clientID = "ARCHIVE";
        const searchOption = "ActiveMessageCorner";
        const searchFilter = "Active";

        const response = await axios.get(
          `${config.api.invokeURL}/dashboard/website/infodesk?clientID=${clientID}&startDate=${startDate}&searchOption=${searchOption}&searchFilter=${searchFilter}`,
          {
            headers: {
              'x-api-key': config.api.key
            }
          }
        );

        const firstRecord = Array.isArray(response.data) ? response.data[0] : null;
        const fetchedMsg = firstRecord?.faithMsg;
        const hasMessage = Boolean(
          fetchedMsg && (fetchedMsg.title || fetchedMsg.subtitle || fetchedMsg.message)
        );

        onMessageAvailabilityChange(hasMessage);

        if (hasMessage) {
          setActivePost(firstRecord);
          setFaithMsg({
            title: fetchedMsg.title || "",
            subtitle: fetchedMsg.subtitle || "",
            message: fetchedMsg.message || ""
          });
          return;
        }

        //setActivePost([]);
        //setFaithMsg({ title: "", subtitle: "", message: "" });
      } catch (error) {
        onMessageAvailabilityChange(false);
        setActivePost([]);
        setFaithMsg({ title: "", subtitle: "", message: "" });
      }
    };
  
          const generateDate = async () => {
          const current_datetime = new Date();
          const date_year = (current_datetime.getFullYear()).toString();
          var date_month = (current_datetime.getMonth() + 1).toString();
          var month_value="";
          date_month.length===1? (month_value=month_value.concat(0,date_month)):(month_value=date_month);
          var date_date = (current_datetime.getDate().toString());
          var date_value="";
          date_date.length===1?(date_value=date_value.toString().concat(0,date_date)):(date_value=date_date);
          var date_hours = (current_datetime.getHours().toString());
          var hours_value="";
          date_hours.length===1?(hours_value=hours_value.toString().concat(0,date_hours)):(hours_value=date_hours);
          var date_minutes = (current_datetime.getMinutes().toString());
          var minutes_value="";
          date_minutes.length===1 ?(minutes_value=minutes_value.toString().concat(0,date_minutes)):(minutes_value=date_minutes);
          var todayDate="";
          const tDate = todayDate.concat(date_year,"-",month_value,"-", date_value);
          //setUserId(accountNo);
          return tDate;
          //console.log("acc : ", accountNo);
      }    

  return (
    <section className={sectionClassName} aria-labelledby="message-of-the-week-title">
      <div className={`container ${compact ? 'home-message-container-compact' : ''}`}>
        <div className="home-message-card">
          {/*<div className="home-message-badge">Message of the Week</div>*/}
          <h2 id="message-of-the-week-title" className="home-message-title">
            {faithMsg.title}
          </h2>
          <p className="home-message-subtitle">
            {faithMsg.subtitle}
            {/*compact ? ' Scroll to read full message.' : ''*/}
          </p>

          <div className="home-message-scroll-region">
            <p className="home-message-text">{faithMsg.message}</p>
          </div>

          {/*<div className="home-message-footer">
            <span className="home-message-chip">Weekly Reflection</span>
            <span className="home-message-chip">{messageWords} words</span>
          </div>*/}
        </div>
      </div>
    </section>
  );
}
